export default __webpack_public_path__ + "assets/images/13de59f1a36b6cb4bca0050160ff0e41.svg";